import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

export function isCarWashSubdomain() {
    return typeof window !== 'undefined' && window.location.hostname.startsWith('lava-rapido.');
}

export function isAutomotiveDetailingSubdomain() {
    return typeof window !== 'undefined' && window.location.hostname.startsWith('estetica-automotiva.');
}

export function isAutoPartSubdomain() {
    return typeof window !== 'undefined' && window.location.hostname.startsWith('auto-pecas.');
}

export function isAutomotiveDispatcherSubdomain() {
    return typeof window !== 'undefined' && window.location.hostname.startsWith('despachante.');
}

export function isOilChangeSubdomain() {
    return typeof window !== 'undefined' && window.location.hostname.startsWith('troca-de-oleo.');
}

export function getSubdomainType() {
    if (isCarWashSubdomain()) return 'car-wash';
    if (isAutomotiveDetailingSubdomain()) return 'automotive-detailing';
    if (isAutoPartSubdomain()) return 'auto-part';
    if (isAutomotiveDispatcherSubdomain()) return 'automotive-dispatcher';
    if (isOilChangeSubdomain()) return 'oil-changer';
    return 'main';
}

export function getWhatsAppMessageBySubdomain() {
    const subdomainType = getSubdomainType();
    
    switch (subdomainType) {
        case 'car-wash':
            return "Olá, desejo ajuda para meu lava rápido com o Garage Hero ERP";
        case 'automotive-detailing':
            return "Olá, desejo ajuda para minha estética automotiva com o Garage Hero ERP";
        case 'auto-part':
            return "Olá, desejo ajuda para minha loja de auto peças com o Garage Hero ERP";
        case 'automotive-dispatcher':
            return "Olá, desejo ajuda para meu despachante automotivo com o Garage Hero ERP";
        case 'oil-changer':
            return "Olá, desejo ajuda para minha empresa de troca de óleo com o Garage Hero ERP";
        default:
            return "Olá, estou no site do GarageHero e desejo ajuda";
    }
}

